import { gql } from 'graphql-request';

import type { RequestDocument } from 'graphql-request';

export const COMPOSITION_TEMPLATES_QUERY: RequestDocument = gql`
  query CompositionTemplatesAll {
    allCompositions {
      id
      label
      internalName
      aspectRatio
      source
      controls
      thumbnail {
        url
      }
    }
  }
`;

export default COMPOSITION_TEMPLATES_QUERY;
